import { render, staticRenderFns } from "./OriginSelect.vue?vue&type=template&id=048ebc22"
import script from "./OriginSelect.vue?vue&type=script&lang=js"
export * from "./OriginSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports